/**
 * RC-4 — Central time formatter.
 * The ONLY place time strings are formatted for display.
 * Every consumer must import from here (Rule 1 — SSOT).
 */

const MN = 'mn-MN';

export const formatTime24 = (iso, opts = {}) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleTimeString(MN, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...opts,
  });
};

export const formatDate = (iso, opts = {}) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(MN, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...opts,
  });
};

export const formatDateTime = (iso, opts = {}) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString(MN, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...opts,
  });
};

export default formatTime24;
